import { CommonPageConstants, ICommonPageConstants } from './CommonPageConstants';
import { ActionSubTypes } from '../../actions/ActionSubTypes';
import { IOyakConstants, OyakConstants } from './OyakPageConstants';
import { FaaliyetAlanlariConstants, IFaaliyetAlaniConstants } from './FaaliyetAlaniPageConstants';
import ImageLinkWithSpanAndTitle from '../../../components/link-component-group/image-link-with-span-and-title/ImageLinkWithSpanAndTitle';

export interface IDashboardConstants extends ICommonPageConstants {
  statisticLinks: { data: { text: string; link: string }[] };
  faaliyetAlanlari: {
    ChildrenElement: (arg0: any) => any;
    defaultColumnCount: number;
    inited: boolean;
    data?: {
      objectName: string;
      title: string;
      spanContent: string;
      imageLink: string;
      redirectLink: string;
      props: IOyakConstants | IFaaliyetAlaniConstants;
    }[] | undefined;
  };
}

export const DashboardConstants: IDashboardConstants = {
  ...CommonPageConstants,
  uid: ActionSubTypes.PAGE_DASHBOARD,
  faaliyetAlanlari: {
    ChildrenElement: ImageLinkWithSpanAndTitle,
    defaultColumnCount: 4,
    inited: false,
  },
  statisticLinks: {
    data: [
      {
        text: 'Gayrimenkullerin Toplam ₺ Değerleri',
        link: '/gayrimenkulToplamDeger',
      },
      {
        text: 'Gayrimenkullerin Toplam Metrekare Dağılımı',
        link: '/gayrimenkulAlan',
      },
      {
        text: 'Grup Şirketleri Kira Bilgileri',
        link: '/kiraBilgileri',
      },
      {
        text: 'Grup Şirketleri Değerleme Bilgileri',
        link: '/degerlemeBilgileri',
      },
      {
        text: 'Yurt Dışı Taşınmaz Bilgileri',
        link: '/tasinmazBilgileri',
      },
      {
        text: 'Maden Sahaları',
        link: '/madenSahalari',
      },
    ],
  },
};
